import React, { useEffect, useRef, Suspense } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { usePageViews } from '@whitelabel/helpers/integrations';
import * as actions from '../../actions';
import { ICustomer } from '../../helpers/types';
import { routes, unauthRoutes, authRoutes } from '../../routes';
import AuthRoute from '../helpers/AuthRoute';
import UnauthRoute from '../helpers/UnauthRoute';
import { StyledLoading } from '../../styled';
import ConsentBanner from '../../components/ConsentBanner';
import ErrorBoundary from '../ErrorBoundary';
import ErrorPage from '../pages/ErrorPage';
import { storeINSInLocalStorage } from '../../helpers/bookings';

interface IAppProps {
  authenticating: boolean;
  checkSession: (...args: any[]) => any;
  customer?: ICustomer;
}

const App = ({ checkSession, authenticating, customer }: IAppProps) => {
  const { pathname } = useLocation();
  const pathRef = useRef(pathname);

  usePageViews();

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  useEffect(() => {
    storeINSInLocalStorage();
    if (pathRef.current !== pathname) {
      window.scroll({ top: 0, left: 0 });
      pathRef.current = pathname;
    }
  }, [pathname]);

  return authenticating ? (
    <StyledLoading />
  ) : (
    <>
      <Suspense fallback={<StyledLoading />}>
        <Switch>
          <Redirect
            from="/(.+)/"
            strict
            exact
            to={{ pathname: pathname.slice(0, -1), search: window.location.search }}
          />
          {unauthRoutes.map((route) => (
            // eslint-disable-next-line react/jsx-key
            <UnauthRoute {...route} />
          ))}

          {authRoutes.map((route) => (
            // eslint-disable-next-line react/jsx-key
            <AuthRoute {...route} />
          ))}

          {routes.map(({ component: Component, ...restProps }) => (
            // @ts-ignore ts-migrate(17004) FIXME: Cannot use JSX unless the '--jsx' flag is provided... Remove this comment to see the full error message
            // eslint-disable-next-line react/jsx-key
            <Route
              {...restProps}
              render={(routeProps) => (
                <ErrorBoundary>
                  <Component {...routeProps} />
                </ErrorBoundary>
              )}
            />
          ))}
          <Route path="/" exact render={() => <StyledLoading />} />
          <Route render={(routerProps) => <ErrorPage {...routerProps} isNoMatch />} />
        </Switch>
      </Suspense>
      {/* @ts-ignore ts-migrate(17004) FIXME: Cannot use JSX unless the '--jsx' flag is provided... Remove this comment to see the full error message */}
      {(!customer || !customer.gdprConsent) && <ConsentBanner customer={customer} />}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  authenticating: state.user.checkingSession,
  customer: state.customer.data,
});

const mapDispatchToProps = {
  checkSession: actions.checkSession,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
